import { experimental_extendTheme } from "@mui/material/styles";
import { theme } from "./theme";
import { extractHexColor } from './hexOpacity'

export const materialTheme = experimental_extendTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: extractHexColor(theme.vars.palette.Surface.Highlight),
        },
        text: { primary: extractHexColor(theme.vars.palette.Content.Strong) },
      },
    },
    dark: {
      palette: {
        primary: {
          main: extractHexColor(theme.vars.palette.Surface.Highlight),
        },
        text: { primary: extractHexColor(theme.vars.palette.Content.Strong) },
      },
    },
  },
});